import { Button, Center, Loader, Stack, Title } from "@mantine/core";
import { Link } from "@tanstack/react-router";

import { useListInvitationsForMe } from "../api/generated/endpoints/teams/teams";
import { StatusScreen } from "../ui/StatusScreen";
import { AdminPanelHint } from "./AdminPanelHint";
import { InvitationList } from "./InvitationsForYou";

export function NotFoundScreen() {
  return (
    <StatusScreen
      title="Page not found"
      message="This page does not exist, or it belongs to a team you are not a member of."
      action={
        <Button component={Link} to="/" variant="light">
          Go to your team
        </Button>
      }
    />
  );
}

/**
 * `/` for a user in no team: their pending invitations, each with Accept ("Invitations for you",
 * spec A2), or what to do when there are none. For staff, that includes the Admin Panel, where
 * their teams are set up (spec ui-perf/staff-no-team-admin-panel).
 */
export function NoTeamScreen() {
  const invitations = useListInvitationsForMe();
  if (invitations.isPending) {
    return (
      <Center mih="60vh">
        <Loader size="sm" aria-label="Looking for your invitations" />
      </Center>
    );
  }
  if (invitations.data !== undefined && invitations.data.length > 0) {
    return (
      <Center mih="60vh" p="md">
        <Stack gap="md" maw={560} w="100%">
          <Title order={1} size="h3">
            You have been invited
          </Title>
          <InvitationList invitations={invitations.data} />
        </Stack>
      </Center>
    );
  }
  return (
    <StatusScreen
      title="You are not in a team yet"
      message="Ask a team admin to invite you, or ask Created.ai staff to create a team for you. Your invitation shows here when you sign in."
      action={
        <>
          <AdminPanelHint />
          <Button component={Link} to="/teams/new" variant="light">
            Create a team
          </Button>
        </>
      }
    />
  );
}
